// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_ENTS = [{
  id: 'ents_bird',
  factionId: FACTIONS.ENTS,
  name: 'Покровитель птиц',
  priceNumens: 8000,
  skinRank: 1,
}, {
  id: 'ents_flower',
  factionId: FACTIONS.ENTS,
  name: 'Дитя природы',
  priceNumens: 35000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
  ]
}, {
  id: 'ents_neon',
  factionId: FACTIONS.ENTS,
  name: 'Неоновый ужас',
  priceNumens: 80000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.DARK_GREEN,
  ]
}, {
  id: 'ents_gold_legacy',
  factionId: FACTIONS.ENTS,
  name: 'Осенний исполин',
  priceNumens: 120000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'ents_ruby_legacy',
  factionId: FACTIONS.ENTS,
  name: 'Хозяин гиблой чащи',
  priceCrystals: 400,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
